<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">企业账号管理</a></li>
                <li><a href="#">充值划账记录</a></li>
            </ul>
        </div>

        <div class="formbody">
            <div class="formtitle"><span>子账号管理</span></div>

            <div id="usual1" class="usual">

                 <ul class="forminfo">
                    <li>
                        <label>邮箱(<b style="color: red;margin-left:-3px;">*</b>)：</label>
                        <div class="vocation">
                            <input v-model="email" type="text" class="dfinput" ref="email_ref"/>
                        </div>
                    </li>
                    <li>
                        <label>密码(<b style="color: red;margin-left:-3px;">*</b>)：</label>
                        <div class="vocation">
                            <input v-model="password" type="password" class="dfinput" ref="password_ref"/>
                        </div>
                    </li>
                    <li>
                        <label>昵称:</label>
                        <div class="vocation">
                            <input v-model="nickname" type="text" class="dfinput" ref="nickname_ref"/>
                        </div>
                    </li>
                    <li>
                        <label>手机号:</label>
                        <div class="vocation">
                            <input v-model="phone" type="text" class="dfinput" ref="phone_ref" maxlength="11"/>
                        </div>
                    </li>
                    <li>
                        <label>&nbsp;</label>
                        <input class="sure" type="button" :disabled="zheceDis" value="注册" @click="zhuce()">
                    </li>
                </ul>
                <div class="xline" style="border-bottom:solid 1px #a6afb4;"></div>
                <span style="margin-bottom: 20px;"></span>
                
                <b>子账号列表</b>
                <div id="tab1" class="tabson">
                    <table class="tablelist">
                        <thead>
                            <tr>								
                                <th>门牌号</th>
                                <th>昵称</th>
                                <th>邮箱</th>
                                <th>绑定手机</th>
                                <th>注册手机</th>
                                <th>注册时间</th>
                                <th>短信账号是否授权</th>
                                <th>操作</th>
                                <th>重置密码</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in list" :class="{odd:index%2!=0}">
                                <td>{{item.account}}</td>
                                <td>{{item.nickname}}</td>
                                <td>{{item.email}}</td>
                                <td>{{item.mobile}}</td>
                                <td>{{item.phone}}</td>
                                <td>{{item.createdate.split('.')[0]}}</td>
                                <td>
                                    <template v-if="item.zgroup == 1">
                                        未授权 <a href="javascript:;" style="margin-left:8px;color:red;" @click="shouquan(1, item.account)">账号授权</a>
                                    </template>
                                    <template v-else-if="item.zgroup == 2">
                                        已授权 <a href="javascript:;" style="margin-left:8px;color:red;" @click="shouquan(2, item.account)">取消授权</a>
                                    </template>
                                </td>
                                <td><a href="javascript:;" style="color:red;" @click="showhuazhang(item.account)">划账</a></td>
                                <td><a href="javascript:;" style="color:red;" @click="showsetpassword(item.account)">重置密码</a></td>
                            </tr>     
                        </tbody>
                    </table>

                    <div class="pagin">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="[pageSize]"
                            :page-size="50"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>
                    
                    <!-- 查询等待 -->
                    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                        top: 0; left: 0;display: block;" v-show="loadingShow"></div>
                    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                        -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                        <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                        <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
                    </div>
                </div>

                <!-- 划账 -->
                <div v-show="huazhangShow" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
                    top: 0; left: 0;display: block;" @click="close();"/>
                <div class="tip" style="z-index:200;display: block;width:500px;" v-show="huazhangShow">
                        <div class="tiptop">
                            <span>
                                企业号 
                                <label style="color:red;">{{parent_account}}</label>
                                 给子账号 
                                 <label style="color:red;">{{child_account}}</label> 
                                 划账
                            </span>
                            <a @click="close();"></a>
                        </div>
                        <ul class="forminfo" style="margin-top:10px;">
                            <li>
                                <label style="width:120px;margin-left:30px;">企业号总账户余额</label>
                                <el-tag style="background: white;">{{parentmoney}} 元</el-tag>
                            </li>
                            <li>
                                <label style="width:120px;margin-left:30px;">子账号总账户余额</label>
                                <el-tag style="background: white;">{{childmoney}} 元</el-tag>
                            </li>
                            <li>
                                <label style="width:120px;margin-left:30px;">划账金额</label>
                                <el-input placeholder="请输入划账金额" v-model="huazhang_money" style="width:220px;" onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
                            </li>
                            <li>
                                <label style="width:120px;margin-left:30px;">备注</label>
                                <el-input placeholder="备注可选填" v-model="discription" type="textarea" style="width:220px;"></el-input>
                            </li>
                            <el-button type="primary" v-show="huazhangDis1" style="margin-left:150px;" :disabled="huazhang_money.trim().length == 0 ? true : false" @click="huazhang()">划账</el-button>
                            <el-button type="primary" v-show="huazhangDis2" style="margin-left:150px;" disabled @click="huazhang()">划账</el-button>
                        </ul>
                    </div>
                </div>

                <!-- 密码重置 -->
                <div v-show="pwdShow" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
                    top: 0; left: 0;display: block;" @click="pwdClose();"/>
                <div class="tip" style="z-index:200;display: block;" v-show="pwdShow">
                        <div class="tiptop"><span style="margin-left: 180px;">密码重置</span><a @click="pwdClose();"></a></div>
                        <ul class="forminfo" style="margin-top:10px;">
                            <li>
                                <label style="width:120px;margin-left:30px;">门牌号</label>
                                <el-tag style="background: white;">{{child_account}}</el-tag>
                            </li>
                            <li>
                                <label style="width:120px;margin-left:30px;">重置密码</label>
                                <el-input placeholder="输入6-12位数字和字母的密码" v-model="password1" type="password" style="width:220px;"></el-input>
                            </li>
                            <li>
                                <label style="width:120px;margin-left:30px;">确认重置密码</label>
                                <el-input placeholder="输入6-12位数字和字母的密码" v-model="password2" type="password" style="width:220px;"></el-input>
                            </li>
                            <el-button type="primary" style="margin-left:150px;" :disabled="password1.trim().length == 0 || password2.trim().length == 0 ? true : false" @click="setpassword()">重置密码</el-button>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'
import {is_email,isMobil, is_number} from '@/assets/js/checkFunction.js'
export default {
    data() {
        return {
            list: [],
            email: '',
            password: '',
            nickname: '',
            phone: '',
            pageIndex: 1,
            pageSize: 50,
            totalCount: 0,
            parentmoney: 0,
            childmoney: 0,
            parent_account: '',
            child_account: '',
            huazhangShow: false,
            huazhang_money: '',
            discription: '',
            pwdShow: false,
            password1: '',
            password2: '',
            loadingShow: true,
            zheceDis: false,
            huazhangDis1: true,
            huazhangDis2: false,
        }
    },
    components: {
        'v-cookie' : cookie,
    },
    mounted() {
        this.pagechange(1)
    },
    methods: {
        handleSizeChange(val) {
            this.pagechange(val)
        },
        handleCurrentChange(val) {
            this.pagechange(val)
        },
        pagechange(pageIndex) {
            this.loadingShow = true;
            var that = this;
            let param = {'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/enterprise/enterpriseusermanage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.list = res.data.userList;
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    that.$alert(res.data.msg)
                }
            })
        },
        zhuce() {
            var that = this
            if(this.email.trim().length == 0)
            {
                this.$alert("请填写邮箱地址！");
                this.$nextTick(this.$refs['email_ref'].focus());
                return false;
            }
            if(!is_email(this.email.trim()))
            {
                this.$alert("邮箱地址不符合规定!");
                this.$nextTick(this.$refs['email_ref'].focus());
                return false;
            }
            if(this.password.trim().length == 0)
            {
                this.$alert("请输入密码！");
                this.$nextTick(this.$refs['password_ref'].focus());
                return false;
            }
            if(this.password.trim().length < 6 || this.password.trim().length > 12)
            {
                this.$alert("密码长度应为6-12位")
                this.$nextTick(this.$refs['password_ref'].focus());
                return false;
            }
            var checkpwd = /^[A-Za-z0-9]+$/
            if(!checkpwd.exec(this.password))
            {
                this.$alert("密码只能输入数字和字母")
                this.$nextTick(this.$refs['password_ref'].focus());
                return false;
            }
            if(this.nickname.trim().length == 0)
            {
                this.$alert("请输入昵称");
                this.$nextTick(this.$refs['nickname_ref'].focus());
                return false;
            }
            if(this.phone.trim().length != 11)
            {
                this.$alert("请输入11位手机");
                this.$nextTick(this.$refs['phone_ref'].focus());
                return false;
            }
            if(!isMobil(this.phone))
            {
                this.$alert("手机号不符合规定");
                this.$nextTick(this.$refs['phone_ref'].focus());
                return false;
            }
            this.zheceDis = true;
            let param = {'email': this.email, 'password': this.password, 'nickname': this.nickname, 'phone': this.phone}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/enterprise/enterprisereguser.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0120004' == res.data.code)
                {
                    that.$alert(res.data.msg);
                    that.email = '';
                    that.password = '';
                    that.nickname = '';
                    that.phone = '';
                    that.pagechange(1);
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        },
        //type = 1进行授权  tpye = 2取消授权
        shouquan(status, account) {
            var that = this
            let param = {'status': status, 'account': account}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/enterprise/enterprisepayaccount.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$alert(res.data.msg);
                    that.pagechange(1);
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        },
        showhuazhang(account) {
            this.getuseraccount(account);
            this.huazhangShow = true;
        },
        //获取金额信息
        getuseraccount(account) {
            var that = this
            let param = {'account': account}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/enterprise/enterprisegetaccount.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.parentmoney = res.data.parentaccount.money;
                    that.childmoney = res.data.childaccount.money;
                    that.parent_account = res.data.parent_account;
                    that.child_account = res.data.child_account;
                    //console.log(that.parent_account)
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        },
        close() {
            this.huazhangShow = false;
            this.huazhang_money = '';
            this.discription = '';
        },
        huazhang() {
            var b=/^(\d+)?$/;
            if(!b.exec(this.huazhang_money))
            {
                this.$alert("划账金额格式不正确");
                return false;
            }
            if(this.huazhang_money < 1)
            {
                this.$alert("划账金额不能少于1元");
                return false;
            }
            this.huazhangDis1 = false;
            this.huazhangDis2 = true;
            var that = this;
            // let param = {'parentmoney': this.parentmoney,'childmoney': this.huazhang_money, 'childaccount': this.child_account, 'discription': this.discription}
            let param = {'money': this.huazhang_money, 'childAccount': this.child_account, 'discription': this.discription}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/enterprise/enterprisepaymoney.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    // that.$alert("划账" + res.data.msg, '提示', {
                    //     confirmButtonText: '确定', 
                    // }).then( () => {
                    //     location.reload();
                    // });
                    that.$alert("划账" + res.data.msg);
                    that.close();
                    that.pagechange(1);
                }
                else
                {
                    that.$alert(res.data.msg)
                }
                that.huazhangDis1 = true;
                that.huazhangDis2 = false;
            })
        },
        //密码重置
        showsetpassword(account) {
            this.child_account = account;
            this.pwdShow = true;
        },
        setpassword() {
            if(this.password1.trim().length == 0)
            {
                this.$alert("请输入密码！");
                this.$nextTick(this.$refs['password1_ref'].focus());
                return false;
            }
            if(this.password1.trim().length < 6 || this.password1.trim().length > 12)
            {
                this.$alert("密码长度应为6-12位")
                this.$nextTick(this.$refs['password1_ref'].focus());
                return false;
            }
            var checkpwd = /^[A-Za-z0-9]+$/
            if(!checkpwd.exec(this.password1))
            {
                this.$alert("密码只能输入数字和字母");
                this.$nextTick(this.$refs['password1_ref'].focus());
                return false;
            }
            if(this.password1 != this.password2)
            {
                this.$alert("两次密码输入不一致!");
                this.$nextTick(this.$refs['password2_ref'].focus());
                return false;
            }
            var that = this;
            let param = {'password1': this.password1, 'password2': this.password2, 'account': this.child_account}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/enterprise/enterpriseresetpassword.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.pwdClose();
                    that.$alert("修改成功");
                    that.pagechange(1);
                }
                else
                {
                    that.$alert(res.data.msg);
                    return false;
                }
            })
        },
        pwdClose() {
            this.password1 = '';
            this.password2 = '';
            this.pwdShow = false;
        },
    }
}

</script>


// WEBPACK FOOTER //
// src/components/enterprise/enterpriseusermanage.vue